import { __exports as c } from "./contact-channels209.js";
import P from "react";
import { __require as S } from "./contact-channels157.js";
import { __require as A } from "./contact-channels208.js";
var E;
function U() {
  if (E) return c;
  E = 1;
  var o = c && c.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(c, "__esModule", { value: !0 }), c.default = h;
  var _ = P, T = o(S()), f = A(), R = {
    cloneElement: _.cloneElement,
    createElement: _.createElement,
    isValidElement: _.isValidElement
  };
  function h(r, a) {
    a === void 0 && (a = {});
    for (var u = [], p = typeof a.replace == "function", m = a.transform || f.returnFirstArg, n = a.library || R, q = n.cloneElement, k = n.createElement, V = n.isValidElement, v = r.length, e = 0; e < v; e++) {
      var t = r[e];
      if (p) {
        var s = a.replace(t, e);
        if (V(s)) {
          v > 1 && (s = q(s, {
            key: s.key || e
          })), u.push(m(s, t, e));
          continue;
        }
      }
      if (t.type === "text") {
        var b = !t.data.trim().length;
        if (b && t.parent && !(0, f.canTextBeChildOfNode)(t.parent) || a.trim && b)
          continue;
        u.push(m(t.data, t, e));
        continue;
      }
      var i = t, l = {};
      g(i) ? ((0, f.setStyleProp)(i.attribs.style, i.attribs), l = i.attribs) : i.attribs && (l = (0, T.default)(i.attribs, i.name));
      var y = void 0;
      switch (t.type) {
        case "script":
        case "style":
          t.children[0] && (l.dangerouslySetInnerHTML = {
            __html: t.children[0].data
          });
          break;
        case "tag":
          t.name === "textarea" && t.children[0] ? l.defaultValue = t.children[0].data : t.children && t.children.length && (y = h(t.children, a));
          break;
        // skip all other cases (e.g., comment)
        default:
          continue;
      }
      v > 1 && (l.key = e), u.push(m(k(t.name, l, y), t, e));
    }
    return u.length === 1 ? u[0] : u;
  }
  function g(r) {
    return f.PRESERVE_CUSTOM_ATTRIBUTES && r.type === "tag" && (0, f.isCustomComponent)(r.name, r.attribs);
  }
  return c;
}
export {
  U as __require
};
//# sourceMappingURL=contact-channels158.js.map
